export default __webpack_public_path__ + "static/media/kenny.042f65b7.jpg";